import React from 'react';

import icon1 from '../../assets/images/gk.png';
import icon2 from '../../assets/images/promanage.png';
import icon3 from '../../assets/images/Image1.png';
import icon4 from '../../assets/images/picon1.png';

import {
  ProjectsContainer,
  ProjectsH1,
  ProjectsH2,
  ProjectsIcon,
  ProjectsP,
  ProjectsWrapper,
  ProjectsCard,
} from './ProjectsElement';

const Projects = () => {
  return (
    <ProjectsContainer id="Projects">
      <ProjectsH1>Recent Projects</ProjectsH1>
      <ProjectsWrapper>
        <ProjectsCard
          href="https://pro-manage-frontend-brown.vercel.app/login"
          target="_blank"
        >
          <ProjectsIcon src={icon2} />
          <ProjectsH2>ProManage</ProjectsH2>
          <ProjectsP>
            "ProManage: Empowering your workflow with precision, effortlessly
            organizing tasks into Backlog, To-Do, In Progress, and Done
            categories for seamless productivity and success."
          </ProjectsP>
        </ProjectsCard>
        <ProjectsCard href="https://gk-vr58.onrender.com/" target="_blank">
          <ProjectsIcon src={icon1} />
          <ProjectsH2>GadgetKart</ProjectsH2>
          <ProjectsP>
            Architected and implemented 'Gadget Kart,' a full-stack e-commerce
            website,creating an intuitive platform for purchasing electronic
            gadgets.
          </ProjectsP>
        </ProjectsCard>
        <ProjectsCard
          href="https://github.com/NirajSrivastava18/InCampJobs"
          target="_blank"
        >
          <ProjectsIcon src={icon3} />
          <ProjectsH2>InCampJobs</ProjectsH2>
          <ProjectsP>
            Developed a dynamic full-stack website for university students,
            offering a user-friendly online job recruitment platform."
          </ProjectsP>
        </ProjectsCard>
        <ProjectsCard href="https://netfilxclone.netlify.app/" target="_blank">
          <ProjectsIcon src={icon4} />
          <ProjectsH2>NetFlix Clone</ProjectsH2>
          <ProjectsP>
            A Netflix frontend design implemented with ReactJS and TMDB
          </ProjectsP>
        </ProjectsCard>
      </ProjectsWrapper>
    </ProjectsContainer>
  );
};

export default Projects;
